import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  useMemo,
} from "react";
import Organization from "../models/Organization";
import { useSearchParams } from "react-router-dom";

const OrganizationContext = createContext();

export const useOrganization = () => useContext(OrganizationContext);

export const OrganizationProvider = ({ children }) => {
  const [params] = useSearchParams();
  const organizationIdQueryParam = params.get("organizationId");
  const dataQueryParam = params.get("data");
  const uidQueryParam = params.get("uid");

  const data = useMemo(() => {
    return dataQueryParam ? JSON.parse(dataQueryParam) : {};
  }, [dataQueryParam]);

  const uid = uidQueryParam || data?.uid || null;

  const [selectedOrganizationId, setSelectedOrganizationId] = useState(null);

  useEffect(() => {
    if (uid && !organizationIdQueryParam) {
      Organization.getOrganizations(uid).then((organizations) => {
        if (organizations.length) {
          setSelectedOrganizationId(organizations[0].id);
        }
      });
    }
  }, [uid, organizationIdQueryParam]);

  useEffect(() => {
    if (organizationIdQueryParam) {
      setSelectedOrganizationId(organizationIdQueryParam);
    }
  }, [organizationIdQueryParam]);

  const value = {
    selectedOrganizationId,
    setSelectedOrganizationId,
  };

  return (
    <OrganizationContext.Provider value={value}>
      {children}
    </OrganizationContext.Provider>
  );
};

export default OrganizationContext;
